<template>
    <div>
        <a-t-list
            modal-title="Nova Compra"
            name="Compra"
            plural-name="Compras"
            fetch-url="purchase"
            fetch-trashed-url="purchase/trashed"
            save-url="purchase"
            entity-search-url="provider/search/"
            entity-name="Fornecedor"
            madeByLabel="Comprador"
            :article-transaction-type="Global.ARTICLE_TRANSACTION_PURCHASE"
            :has-discount="false"
        ></a-t-list>
    </div>
</template>

<script>
    import ATList from '../article_transaction/ATList';
    import {Global} from "../../config";

    export default {
        name: "Purchase",
        data(){
            return {
                Global,
            }
        },

        components: {
            ATList,
        },

        methods: {

        },

        computed: {

        }
    }
</script>

<style scoped>

</style>

<!--<template>-->
    <!--<div>-->
        <!--<v-toolbar flat color="white">-->
            <!--<v-toolbar-title v-ripple style="cursor: pointer" @click="fetchData(onlyTrashed)">-->
                <!--<v-tooltip top>-->
                    <!--<template v-slot:activator="{ on }">-->
                        <!--<span v-on="on">Compras {{onlyTrashed ? ' removidas' : ''}}</span>-->
                    <!--</template>-->
                    <!--<span>Clique para actualizar</span>-->
                <!--</v-tooltip>-->
            <!--</v-toolbar-title>-->
            <!--<v-divider-->
                    <!--class="mx-2"-->
                    <!--inset-->
                    <!--vertical-->
            <!--&gt;</v-divider>-->
            <!--<v-spacer></v-spacer>-->
            <!--<v-text-field class="mr-2 mb-2" fill-height-->
                          <!--v-model="search"-->
                          <!--append-icon="search"-->
                          <!--label="procurar compras..."-->
                          <!--single-line-->
                          <!--hide-details-->
            <!--&gt;</v-text-field>-->

            <!--&lt;!&ndash;Dialog for add and edit&ndash;&gt;-->
            <!--<v-btn v-if="!onlyTrashed" color="primary" icon @click="openModal"><v-icon>add</v-icon></v-btn>-->
            <!--<purchase-form-modal-->
                <!--:paymentConditions="paymentConditions"-->
                <!--:paymentMethods="paymentMethods"-->
                <!--:situations="situations">-->
            <!--</purchase-form-modal>-->
        <!--</v-toolbar>-->


        <!--&lt;!&ndash;Data table&ndash;&gt;-->
        <!--<v-data-table xs12 sm6 md4-->
                      <!--:headers="headers"-->
                      <!--:items="purchases"-->
                      <!--:search="search"-->
                      <!--:loading="loading"-->
                      <!--class="elevation-1"-->
                      <!--no-data-text="Nenhuma compra ainda"-->
                      <!--no-results-text="nenhum resultado"-->
                      <!--rows-per-page-text="por página"-->
                      <!--disable-initial-sort-->
        <!--&gt;-->
            <!--<v-progress-linear small v-slot:progress color="indigo" indeterminate></v-progress-linear>-->
            <!--<template slot="items" slot-scope="props" >-->
                <!--<td class="text-xs-left">{{ props.item.code }}</td>-->
                <!--<td class="text-xs-left">{{ props.item.provider.name}}</td>-->
                <!--<td class="text-xs-center">{{ props.item.type_situation.name}}</td>-->
                <!--<td class="text-xs-center">{{ props.item.purchase_date | formatDate}}</td>-->
                <!--<td class="text-xs-right">{{ props.item.created_at | formatDate}}</td>-->
                <!--<td class="justify-center layout px-0">-->
                    <!--<v-icon v-if="!onlyTrashed" small class="mr-2" @click="showItem(props.item)">visibility</v-icon>-->
                    <!--<v-icon v-if="!onlyTrashed" small class="mr-2" @click="editItem(props.item)">edit</v-icon>-->
                    <!--<v-icon v-if="!onlyTrashed" small class="mr-2" @click="deleteItem(props.item)">block</v-icon>-->
                    <!--<v-icon  v-if="onlyTrashed" small class="mr-2" @click="restoreTrashedItem(props.item)">replay</v-icon>-->
                    <!--&lt;!&ndash;<v-icon v-if="onlyTrashed" small class="mr-2" @click="deleteTrashedItem(props.item)">delete</v-icon>&ndash;&gt;-->
                <!--</td>-->
            <!--</template>-->
            <!--<template v-if="error_fetching" slot="no-data">-->
                <!--<v-btn flat color="primary" @click="fetchData(onlyTrashed)"><v-icon>refresh</v-icon></v-btn>-->
                <!--<span class="text-xs-center">nenhum dado encontrado</span>-->
            <!--</template>-->
        <!--</v-data-table>-->

        <!--&lt;!&ndash;Confirmation Dialog&ndash;&gt;-->
        <!--<v-dialog persistent max-width="290" v-model="openConfirmationDialog" @close="openConfirmationDialog = false">-->
            <!--<v-card>-->
                <!--&lt;!&ndash;<v-card-title class="headline">Use Google's location service?</v-card-title>&ndash;&gt;-->
                <!--<v-card-text class="text-xs-center">-->
                    <!--<p v-if="confirmationModalOp === 1">Tens a certeza que queres eliminar a compra de código <br> <b>{{selectedPurchase.code}}</b>?</p>-->
                    <!--<p v-if="confirmationModalOp === 2">Tens a certeza que queres <br> <span class="green&#45;&#45;text text&#45;&#45;darken-2">restaurar</span> a compra de código <br><b>{{selectedPurchase.code}}</b>?</p>-->
                    <!--<p v-if="confirmationModalOp === 3">Tens a certeza que queres <br> <span class="red&#45;&#45;text text&#45;&#45;darken-2">eliminar permanentemente</span><br> a compra de código <br><b>{{selectedPurchase.code}}</b>?</p>-->

                <!--</v-card-text>-->
                <!--<v-card-actions>-->
                    <!--<v-spacer></v-spacer>-->
                    <!--<div v-if="!loading_modal">-->
                        <!--<v-btn color="red darken-1" flat @click="confirmationDialogYes">Sim</v-btn>-->
                        <!--<v-btn color="grey darken-1" flat @click="close">Não</v-btn>-->
                    <!--</div>-->
                    <!--<v-progress-circular v-else indeterminate color="primary" m-2 ></v-progress-circular>-->
                <!--</v-card-actions>-->
            <!--</v-card>-->
        <!--</v-dialog>-->

        <!--&lt;!&ndash;Snackbar&ndash;&gt;-->
        <!--<v-snackbar-->
                <!--v-model="snackbar"-->
                <!--bottom-->
                <!--right-->
                <!--:timeout=3000-->
                <!--:color='snackbar_color'-->
        <!--&gt;-->
            <!--{{ text }}-->
            <!--<v-btn color="white" flat @click="snackbar = false"><v-icon small>clear</v-icon></v-btn>-->
        <!--</v-snackbar>-->

        <!--&lt;!&ndash;Button Removed purchases&ndash;&gt;-->
        <!--<v-btn @click="fetchData(!onlyTrashed)" slot="activator" dark small :color="onlyTrashed ? 'red' : 'indigo'">-->
            <!--{{onlyTrashed ? 'Sair de ' : ''}}Compras removidos-->
        <!--</v-btn>-->

        <!--&lt;!&ndash;<div>&ndash;&gt;-->
        <!--&lt;!&ndash;<button @click.prevent="openMyDialog()">my button</button>&ndash;&gt;-->
        <!--&lt;!&ndash;</div>&ndash;&gt;-->


    <!--</div>-->
<!--</template>-->

<!--<script>-->
    <!--import Vue from 'vue';-->
    <!--import {mapGetters} from 'vuex';-->
    <!--import {mapActions} from 'vuex';-->

    <!--import {maxLength, minLength, minValue, required} from 'vuelidate/lib/validators'-->
    <!--import {eventBus} from "../../main";-->

    <!--import PurchaseFormModal from '../purchase/ATFormModal.vue';-->

    <!--export default {-->
        <!--created () {-->
            <!--let vm = this;-->
            <!--this.onPurchaseAddOrEdited(vm);-->
            <!--this.selectedCompany = this.getNewCompany();-->
            <!--this.selectedPurchase = this.getNewPurchase();-->
            <!--this.fetchData(false);-->
            <!--this.purchases = [];-->

        <!--},-->

        <!--beforeDestroy(){-->
            <!--eventBus.$off('onPurchaseAdded');-->
            <!--this.close();-->
        <!--},-->

        <!--data(){-->
            <!--return {-->
                <!--loading: false, //loading for list of purchases in the datatable-->
                <!--loading_modal: false, //loading for the action buttons in form modal-->
                <!--error_fetching: false,  //error for fetching list of purchases in the datatable-->
                <!--search: '', //search for the datatable-->
                <!--openConfirmationDialog: false, //loads confirmation modal with yes or no-->
                <!--headers: [-->
                    <!--{ text: 'Código', align: 'left', value: 'code' },-->
                    <!--{ text: 'Fornecedor', align: 'left', value: 'provider_name'},-->
                    <!--{ text: 'Situação', align: 'center', value: 'situation_name'},-->
                    <!--{ text: 'Data Compra', align: 'cener', value: 'deadline'},-->
                    <!--{ text: 'Adicionado em', align: 'right', value: 'created_at' },-->
                    <!--{ text: 'Actions', align: 'right', value: '', sortable: false }-->
                <!--],-->

                <!--purchases: [],-->
                <!--paymentConditions: [],-->
                <!--paymentMethods: [],-->
                <!--purchaseChannels: [],-->
                <!--situations: [],-->
                <!--selectedIndex: -1, //the index of the selected purchase, useful for delete, add, update, restore, permanently delete-->
                <!--onlyTrashed: false, //displays only trashed items or not-->
                <!--confirmationModalOp: 0, //used for getting the confirmation actions (delete, restore, permanently delete) from confirmation modal-->


                <!--//Snackbar-->
                <!--snackbar: false,-->
                <!--snackbar_color: 'success',-->
                <!--timeout: 3000,-->
                <!--text: '',-->
            <!--}-->
        <!--},-->

        <!--components: {-->
            <!--PurchaseFormModal,-->
        <!--},-->

        <!--computed: {-->
            <!--showPurchaseModal: {-->
                <!--get(){-->
                    <!--return this.$store.getters.getShowPurchaseModal;-->
                <!--},-->
                <!--set(value){-->
                    <!--this.$store.dispatch('setShowPurchaseModal', value);-->
                <!--}-->
            <!--},-->
            <!--selectedCompany: {-->
                <!--get(){-->
                    <!--return this.$store.getters.getSelectedCompany;-->
                <!--},-->
                <!--set(value){-->
                    <!--this.$store.dispatch('setSelectedCompany', value);-->
                <!--}-->
            <!--},-->
            <!--selectedPurchase: {-->
                <!--get(){-->
                    <!--return this.$store.getters.getSelectedPurchase;-->
                <!--},-->
                <!--set(value){-->
                    <!--this.$store.dispatch('setSelectedPurchase', value);-->
                <!--}-->
            <!--},-->
            <!--purchaseShow: {-->
                <!--get(){-->
                    <!--return this.$store.getters.getPurchaseShow;-->
                <!--},-->
                <!--set(value){-->
                    <!--this.$store.dispatch('setPurchaseShow', value);-->
                <!--}-->
            <!--},-->
        <!--},-->

        <!--methods: {-->
            <!--showSnackBar(message, color){-->
                <!--this.snackbar = true;-->
                <!--this.text = message;-->
                <!--this.snackbar_color = color;-->
            <!--},-->

            <!--getNewPurchase(){-->
                <!--return {-->
                    <!--code: '',-->
                    <!--providers_id: '',-->
                    <!--purchase_time: '',-->
                    <!--purchase_tax: '',-->
                    <!--responsible: '',-->
                    <!--types_situation_id: '',-->
                    <!--types_payment_condition_id: '',-->
                    <!--types_payment_method_id: ''-->
                <!--};-->
            <!--},-->

            <!--getNewCompany(){-->
                <!--return {-->
                    <!--id: '',-->
                    <!--name: '',-->
                    <!--company_types_id: '',-->
                    <!--company_categories_id: '',-->
                    <!--nib_bi: '',-->
                    <!--nif: '',-->
                    <!--state: '',-->
                    <!--countries_id: '',-->
                    <!--cities_id: '',-->
                    <!--address: '',-->
                    <!--contacts_json: [{ name:'Empresa',  contactLines: [ { phone: '', mobile_phone: '', email: '', fax: ''} ] }],-->
                    <!--description: '',-->
                    <!--last_article_code: '',-->
                    <!--last_invoice_code: '',-->
                    <!--last_receipt_code: '',-->
                    <!--created_at: '',-->
                <!--};-->
            <!--},-->

            <!--fetchData(onlyTrashed = false){-->
                <!--try{-->
                    <!--this.onlyTrashed = onlyTrashed;-->
                    <!--let url = onlyTrashed ? 'purchase/trashed' : 'purchase';-->

                    <!--this.purchases = [];-->
                    <!--this.loading = true;-->
                    <!--this.error_fetching = false;-->
                    <!--Vue.axios.get(url)-->
                        <!--.then(response => {-->
                            <!--// this.consoleLog(response);-->
                            <!--if(!response.data.success){-->
                                <!--this.loading = false;-->
                                <!--this.error_fetching = true;-->
                                <!--this.showSnackBar('Erro ao carregar lista de Compras', 'error');-->
                                <!--return;-->
                            <!--}-->

                            <!--if(onlyTrashed){-->
                                <!--// this.setPurchases(response.data.response);-->
                                <!--this.purchases = response.data.response;-->
                            <!--}else {-->
                                <!--this.purchases = response.data.response.purchases;-->
                                <!--this.paymentConditions = response.data.response.paymentConditions;-->
                                <!--this.paymentMethods = response.data.response.paymentMethods;-->
                                <!--this.situations = response.data.response.purchaseChannels;-->
                            <!--}-->

                            <!--this.consoleLog(response);-->
                            <!--this.totalRows = this.purchases.length;-->
                            <!--this.loading = false;-->
                        <!--}).catch(error => {-->
                        <!--this.consoleLog(error);-->
                        <!--this.loading = false;-->
                        <!--this.error_fetching = true;-->
                        <!--this.showSnackBar('Erro ao carregar lista de compras', 'error');-->
                    <!--});-->
                <!--}catch (e) {-->
                    <!--this.showSnackBar('Ocorreu um erro ao carregar lista de compras!', 'error');-->
                    <!--this.loading_modal = false;-->
                <!--}-->
            <!--},-->

            <!--delete(){-->
                <!--try{-->
                    <!--this.loading_modal = true;-->
                    <!--let code = this.selectedPurchase.code;-->
                    <!--Vue.axios.delete('purchase/'+this.selectedPurchase.id)-->
                        <!--.then(response => {-->
                            <!--this.consoleLog(response);-->
                            <!--if(!response.data.success){-->
                                <!--this.showSnackBar('Erro ao remover compra', 'error');-->
                                <!--return;-->
                            <!--}-->
                            <!--this.purchases.splice(this.selectedIndex, 1);-->
                            <!--this.showSnackBar('Compra de código ['+code+'] removido com sucesso', 'success');-->
                        <!--}).catch(error => {-->
                        <!--this.consoleLog(error);-->
                        <!--this.showSnackBar('Ocorreu um erro ao remover compra', 'error');-->
                    <!--}).finally( ()=> {-->
                        <!--this.loading_modal = false;-->
                        <!--this.openConfirmationDialog = false;-->
                        <!--this.selectedPurchase = this.getNewPurchase();-->
                    <!--});-->
                <!--}catch (e) {-->
                    <!--this.showSnackBar('Ocorreu um erro ao remover compra!', 'error');-->
                    <!--this.loading_modal = false;-->
                <!--}-->
            <!--},-->

            <!--restoreTrashed(){-->
                <!--try{-->
                    <!--this.loading_modal = true;-->
                    <!--let code = this.selectedPurchase.code;-->
                    <!--Vue.axios.put('purchase/trashed/restore/'+this.selectedPurchase.id)-->
                        <!--.then(response => {-->
                            <!--if(!response.data.success){-->
                                <!--this.$toastr.error('Erro ao remover compra', '');-->
                                <!--this.loading_modal = false;-->
                                <!--return;-->
                            <!--}-->
                            <!--this.purchases.splice(this.selectedIndex, 1);-->
                            <!--this.showSnackBar('Compra de código ['+code+'] restaurado com sucesso', 'success');-->
                        <!--}).catch(error => {-->
                        <!--// this.consoleLog(error);-->
                        <!--this.showSnackBar('Erro ao restaurar compra', 'error');-->
                    <!--}).finally( ()=> {-->
                        <!--this.loading_modal = false;-->
                        <!--this.openConfirmationDialog = false;-->
                        <!--this.selectedIndex = -1;-->
                        <!--this.selectedPurchase = this.getNewPurchase();-->
                    <!--});-->
                <!--}catch (e) {-->
                    <!--this.showSnackBar('Ocorreu um erro ao restaurar compra!', 'error');-->
                    <!--this.loading_modal = false;-->
                <!--}-->
            <!--},-->

            <!--deleteTrashed(){-->
                <!--try{-->
                    <!--this.loading_modal = true;-->
                    <!--let code = this.selectedPurchase.code;-->
                    <!--Vue.axios.delete('purchase/trashed/delete/'+this.selectedPurchase.id)-->
                        <!--.then(response => {-->
                            <!--if(!response.data.success){-->
                                <!--this.$toastr.error('Erro ao remover compra', '');-->
                                <!--this.loading_modal = false;-->
                                <!--return;-->
                            <!--}-->
                            <!--this.purchases.splice(this.selectedIndex, 1);-->
                            <!--this.showSnackBar('Compra de código ['+code+'] foi eliminado permanentemente com sucesso', 'success');-->
                        <!--}).catch(error => {-->
                        <!--this.showSnackBar('Erro ao eliminar permanentemente o compra', 'error');-->
                        <!--// this.consoleLog(error);-->
                    <!--}).finally( ()=> {-->
                        <!--this.loading_modal = false;-->
                        <!--this.openConfirmationDialog = false;-->
                        <!--this.selectedIndex = -1;-->
                        <!--this.selectedPurchase = this.getNewPurchase();-->
                    <!--});-->
                <!--}catch (e) {-->
                    <!--this.showSnackBar('Ocorreu um erro ao eliminar permanentemente a compra!', 'error');-->
                    <!--this.loading_modal =false;-->
                    <!--// this.consoleLog(e);-->
                <!--}-->
            <!--},-->

            <!--onPurchaseAddOrEdited(vm){-->
                <!--eventBus.$on('onPurchaseAdded', function(purchase){-->
                    <!--try{-->
                        <!--if(vm.selectedPurchase.id > 0){-->
                            <!--vm.purchases.splice(vm.selectedIndex, 1, purchase);-->
                            <!--vm.showSnackBar(purchase.name+' atualizado com sucesso', 'success');-->
                        <!--}else{-->
                            <!--vm.purchases.unshift(purchase);-->
                            <!--vm.showSnackBar(purchase.name+ ' adicionado com sucesso', 'success');-->
                        <!--}-->
                        <!--vm.close();-->
                        <!--vm.selectedPurchase = vm.getNewPurchase();-->
                    <!--}catch (e) {-->
                        <!--vm.showSnackBar('Erro ao adicionar compra', 'error');-->
                    <!--}-->
                <!--})-->
            <!--},-->

            <!--getContactsJson(item){-->
                <!--if(!item.contacts_json) return [];-->
                <!--if(item.contacts_json instanceof Array)-->
                    <!--return item.contacts_json;-->
                <!--else-->
                    <!--return JSON.parse(item.contacts_json);-->
            <!--},-->

            <!--showItem (item) {-->
                <!--this.purchaseShow = true;-->
                <!--this.selectedIndex = this.purchases.indexOf(item);-->
                <!--this.selectedPurchase = item;-->
                <!--this.selectedPurchase.contacts_json = this.getContactsJson(item);-->
                <!--this.consoleLog(JSON.stringify(this.selectedPurchase));-->
                <!--this.showPurchaseModal = true-->
            <!--},-->

            <!--editItem (item) {-->
                <!--this.selectedIndex = this.purchases.indexOf(item);-->
                <!--this.selectedPurchase = item;-->
                <!--this.selectedPurchase.contacts_json = this.getContactsJson(item);-->
                <!--this.showPurchaseModal = true-->
            <!--},-->

            <!--deleteItem (item) {-->
                <!--this.confirmationModalOp = 1;-->
                <!--this.selectedIndex = this.purchases.indexOf(item);-->
                <!--// this.$store.dispatch('setSelectedPurchase', item);-->
                <!--this.selectedPurchase = item;-->
                <!--this.openConfirmationDialog = true;-->
            <!--},-->

            <!--restoreTrashedItem (item){-->
                <!--this.confirmationModalOp = 2;-->
                <!--this.selectedIndex = this.purchases.indexOf(item);-->
                <!--this.selectedPurchase = item;-->
                <!--this.openConfirmationDialog = true;-->
            <!--},-->

            <!--deleteTrashedItem (item){-->
                <!--this.confirmationModalOp = 3;-->
                <!--this.selectedIndex = this.purchases.indexOf(item);-->
                <!--this.selectedPurchase = item;-->
                <!--this.openConfirmationDialog = true;-->
            <!--},-->

            <!--close () {-->
                <!--this.showPurchaseModal = false;-->
                <!--this.openConfirmationDialog = false;-->
                <!--this.loading = false;-->
                <!--this.purchaseShow = false;-->
                <!--if(this.$v) this.$v.$reset();-->
                <!--setTimeout(() => {-->
                    <!--this.selectedPurchase = this.getNewPurchase();-->
                    <!--this.selectedIndex = -1-->
                <!--}, 300)-->
            <!--},-->

            <!--openModal(){-->
                <!--this.selectedPurchase = this.getNewPurchase();-->
                <!--this.showPurchaseModal = true;-->
            <!--},-->

            <!--getNewEmptyContact(){-->
                <!--return { phone: '', mobile_phone: '', email: '', fax: ''}-->
            <!--},-->

            <!--confirmationDialogYes(){-->
                <!--if(this.confirmationModalOp === 1){-->
                    <!--this.delete();-->
                <!--}else if(this.confirmationModalOp === 2){-->
                    <!--this.restoreTrashed();-->
                <!--}else if(this.confirmationModalOp === 3){-->
                    <!--this.deleteTrashed();-->
                <!--}-->
            <!--},-->

        <!--},-->


    <!--}-->
<!--</script>-->

<!--<style scoped>-->
    <!--.mborder {-->
        <!--border: 1px solid black;-->
    <!--}-->
<!--</style>-->